module.exports = {"id":"190330","name":"Nicola Rigoni","rating":"74","photo":"./data/images/photos/4/190330.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicolaRigoni0.json
// module id = 3184
// module chunks = 0